module.exports = __webpack_public_path__ + "static/media/eventSuccessfull.b9f003c1.svg";